import React from 'react';

import { connect } from 'react-redux';

import Modal from 'bs/Modal';
import Portal from 'components/Portal';

import { Button } from 'bs';

const defaultState = {
    available: true,
    message: '',
};

export const API_STATUS_DOWN = 'API_STATUS_DOWN';
export const API_STATUS_UP = 'API_STATUS_UP';

export const reducer = (state = defaultState, action = {}) => {
    switch (action.type) {
        case API_STATUS_DOWN:
            return {
                available: false,
                message: action.message || 'Could not reach API',
            };

        case API_STATUS_UP:
            return {
                available: true,
                message: '',
            };

        default:
            return state;
    }
};

const APIModal = ({ message, dismiss }) => (
    <Portal>
        <Modal>
            <p className='text-muted'>{message}</p>
            <Button flavor='info' onClick={dismiss}>
                Try Again
            </Button>
        </Modal>
    </Portal>
);

export const RequireAPI = connect(
    ({ api_status }, ownProps) => ({ ...api_status }),
    (dispatch, ownProps) => ({
        dismiss: () => dispatch({ type: API_STATUS_UP }),
    })
)(function RequireAPI({ available, message, dismiss, children }) {
    return available ? children : <APIModal message={message} dismiss={dismiss} />;
});
